/**
 * Copyright (C) 2019 Impulsis <info@impulsis.com>. All rights reserved.
 *
 * All information herein, source code below as well as the Morpheus system itself and all related
 * software (“Items”) are proprietary to Impulsis. Impulsis is the sole copyright owner of the Items.
 * Any use, reproduction, or disclosure of the Items without the written permission of Impulsis
 * is prohibited.
 */

/**
 * Output filter
 * Converts date to format provided as an argument or defined in config file (if argument not provided)
 * @param {String} date
 * @param {String} format
 */

export const date = function (date: string, format: string) {
  if (!date) {
    return ''
  }

  return new Date(date).toLocaleString(format).replace(/\s+/g, '\u00a0')
}
